import { HeadlessForm } from '@universal-ember/form';

<template>
  <HeadlessForm @validateOn="focusout" @revalidateOn="input" as |form|>
    <form.Field @name="email" as |field|>
      <div class="my-2 flex flex-col">
        <field.Label>Email</field.Label>
        <field.Input @type="email" required class="border rounded px-2" />
        <field.Errors />
      </div>
    </form.Field>

    <button type="submit">Submit</button>
  </HeadlessForm>
</template>